import { useRouteSection } from '@/hooks/useRouteSection';
import { TAKAFUL } from '@/constants';

// Capitalize first character on String
export function capitalizeFirstChar(letter: string): string {
  if (typeof letter !== 'string' || letter.length === 0) {
    return '';
  }
  return letter.charAt(0).toUpperCase() + letter.slice(1);
}

export function getProductType() {
  return useRouteSection() === TAKAFUL ? true : false;
}
